import React, { lazy, Suspense, useState } from 'react';
import DS_AccordionCommonElementMUI from 'mui/components/elements/DS_AccordionCommon';
import { StyledAccordionWrapper } from './styles';

const Markdown = lazy(() => import('components/elements/Markdown'));

const DS_AdditionalLocationInfo = ({ data }) => {
  if (!data || !data[0]?.content?.markdown?.html) return;

  const heading = data[0]?.heading;
  const markdown = data[0].content.markdown.html;
  const [accordionOpen, setAccordionOpen] = useState(false);
  const handleAccordionChange = () => (event, isExpanded) => setAccordionOpen(isExpanded);

  return (
    <StyledAccordionWrapper>
      <DS_AccordionCommonElementMUI
        expanded={accordionOpen}
        isOpenedByDefault={false}
        onChange={handleAccordionChange()}
        headerContent={<div>{heading}</div>}
        mainContent={
          <Suspense fallback={<div />}>
            <Markdown>{markdown}</Markdown>
          </Suspense>
        }
      ></DS_AccordionCommonElementMUI>
    </StyledAccordionWrapper>
  );
};

export default DS_AdditionalLocationInfo;
